import { TraitTypeSkeletonKey } from '../traitTypes/TraitTypeSkeletonKey';
import { TraitRegistryCategory } from '../TraitRegistryCategory';
import { TraitTypeSelect } from '../traitTypes/TraitTypeSelect';
import { TraitTypeActor } from '../traitTypes/TraitTypeActor';
import { TraitTypeNumeric } from '../traitTypes/TraitTypeNumeric';
import { TraitTypeTextarea } from '../traitTypes/TraitTypeTextarea';
import { TraitTypeSelectWithPreview } from '../traitTypes/TraitTypeSelectWithPreview';
export class TraitRegistryAspectContent extends TraitRegistryCategory {
    label = 'Content';
    constructor(parent) {
        super(parent);
        super.init();
    }
    image = () => new TraitTypeActor({
        multiple: true,
        unifier: 'content'
        /*  label: 'Bild',
        aspectsTemplate: {
          essence: ['imageFile', 'imageWidth', 'imageHeight'],
          outer: [],
          inner: [],
          core: ['contentOrderPosition']
        } */
    });
    text = () => new TraitTypeActor({
        multiple: true,
        unifier: 'content'
        /*  aspectsTemplate: {
          inner: ['jsxTag'],
          core: ['textBasis', 'transformText']
        } */
    });
    box = () => new TraitTypeActor({
        multiple: true,
        unifier: 'content'
    });
    table = () => new TraitTypeActor({
        multiple: true,
        unifier: 'content'
        /*   label: 'Tabelle',
        aspectsTemplate: {
          core: ['rows', 'columns']
        } */
    });
    rows = () => new TraitTypeNumeric( /*{
        label: 'Reihen',
        min: 1,
        default: 1
      }*/);
    columns = () => new TraitTypeNumeric( /*{
        label: 'Spalten',
        min: 1,
        default: 1
      }*/);
    gap = () => new TraitTypeActor({
        multiple: true,
        unifier: 'content'
    });
    video = () => new TraitTypeActor({
        multiple: true,
        unifier: 'content',
        key: 'video',
        /* creates: ['mediaSequence'] as any,
         createTraits: ({ at }) => {
           if (!at.trait.value) return [];
   
           const medSeqTrait = runtime.class.Trait.fromSerialized({
             key: 'mediaSequence',
             traitGroup: at.trait.traitGroup,
             value: {
               type: 'medseq',
               mediumLabel: at.trait.value.mediumLabel,
               sequenceName: 'auto'
             }
           });
           medSeqTrait.isGenerated = true;
           return [medSeqTrait];
         } */
        /*   icon: 'far fa-file-video',
        aspectsTemplate: {
          essence: ['imageWidth', 'imageWidth'],
          outer: [],
          inner: [],
          core: ['contentOrderPosition']
        } */
    });
    //  readonly bgVideo = () => new TraitTypeActor({});
    audio = () => new TraitTypeActor({
        multiple: true,
        unifier: 'content'
        /*  icon: 'far fa-file-audio',
        aspectsTemplate: {
          core: ['contentOrderPosition']
        } */
    });
    childFromSkeleton = new TraitTypeSkeletonKey({
        multiple: true,
        unifier: 'content'
        /*  label: 'Inhalt',
        aspectsTemplate: { core: ['contentOrderPosition'] } */
    });
    siblingFromSkeleton = () => new TraitTypeSkeletonKey({
        /*   label: 'Geschwister von SkeletonRegistry', */
        multiple: true
    });
    childFromAspectName = () => new TraitTypeSelect({
        multiple: true,
        unifier: 'content'
        /*    label: 'Inhalt (Eigener Aspekt)',
        init: ({ actor }) =>
          `group${actor.actorAspects.allAspectsArray.filter(a => a.name.includes('group')).length + 1}`,
        select: ({ actor, aspect }) =>
          [...actor.actorAspects.allAspectsArray.filter(a => a.name !== aspect.name).map(aspect => [aspect.name])] as any,
        aspectsTemplate: { core: ['contentOrderPosition'] } */
    });
    contentOrderPosition = () => new TraitTypeNumeric( /*{
      label: 'Position (Reihenfolge)',
      min: -100,
      max: 100,
      step: 1
    }*/);
    layoutOfChildren = new TraitTypeSelectWithPreview({
        default: 'flex_row' /*
      label: 'Inhalts Layout',
      select: [
        ['flex_row', 'flex →'],
        ['flex_column', 'flex ↓'],
        ['absolute'],
        ['block'],
        ['inline-block'],
        ['grid'],
        ['none'],
        ['flex_row-reverse', 'flex ←'],
        ['flex_column-reverse', 'flex ↑']
      ], */,
        key: 'layoutOfChildren',
        creates: ['position', 'wrapChildren'],
        createTraits: ({ at }) => {
            const layout = at.trait.value;
            if (layout.includes('absolute')) {
                return [{ key: 'position', value: 'relative' }];
            }
            if (layout.includes('inline-block')) {
            }
            if (layout.includes('grid')) {
                return [{ key: 'wrapChildren', value: 'gridLayout' }];
            }
            return [];
        },
        classNames: ({ at }) => [`childLayout_${at.trait.value}`]
    });
    htmlChild = () => new TraitTypeTextarea({
        key: 'htmlChild',
        creates: ['childFromSkeleton'],
        /*  aspectsTemplate: { core: ['jsxTag'] }, */
        createTraits: ({ at }) => [
            {
                key: 'childFromSkeleton',
                traitGroup: at.trait.traitGroup,
                value: 'customHtmlNode'
            }
        ]
    });
}
